"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _paginationItem = _interopRequireDefault(require("./pagination-item"));

var _pagination = require("./pagination.styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const PaginationEllipsis = ({
  value,
  isBefore,
  onlyDots,
  animated,
  bordered,
  onClick
}) => {
  const [showMore, setShowMore] = (0, _react.useState)(false);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_paginationItem.default, {
    value: value,
    onlyDots: onlyDots,
    animated: animated,
    bordered: bordered,
    onClick: e => onClick && onClick(e),
    onMouseEnter: () => setShowMore(true),
    onMouseLeave: () => setShowMore(false),
    children: showMore ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_pagination.StyledPaginationEllipsis, {
      role: "presentation",
      focusable: "false",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      shapeRendering: "geometricPrecision",
      className: "nextui-pagination-ellipsis",
      isEllipsis: true,
      isBefore: isBefore,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M13 17l5-5-5-5"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M6 17l5-5-5-5"
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_pagination.StyledPaginationEllipsis, {
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      shapeRendering: "geometricPrecision",
      isEllipsis: false,
      isBefore: isBefore,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "12",
        cy: "12",
        r: "1",
        fill: "currentColor"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "19",
        cy: "12",
        r: "1",
        fill: "currentColor"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "5",
        cy: "12",
        r: "1",
        fill: "currentColor"
      })]
    })
  });
};

var _default = PaginationEllipsis;
exports.default = _default;
module.exports = exports.default;